import axios from "axios";
import { APP_SETTINGS } from "../../config";

export function getProjects() {
  return axios.get(APP_SETTINGS.API_PATH.INCOME.getAllProjects);
}
export function getAllIncomeTypes() {
  return axios.get(APP_SETTINGS.API_PATH.INCOME.INCOMETYPE.getIncomeTypes);
}
export function addNewIncomeType(incomeTypeData) {
  return axios.post(
    APP_SETTINGS.API_PATH.INCOME.INCOMETYPE.addIncomeType,
    incomeTypeData
  );
}
export function deleteIncomeType(incomeTypeId) {
  return axios.post(APP_SETTINGS.API_PATH.INCOME.INCOMETYPE.deleteIncomeType, {
    requestId: incomeTypeId,
  });
}
export function addIncome(incomeData) {
  return axios.post(APP_SETTINGS.API_PATH.INCOME.addNewIncome, incomeData);
}
export function deleteIncome(incomeId) {
  return axios.post(APP_SETTINGS.API_PATH.INCOME.deleteIncome, {
    requestId: incomeId,
  });
}
export function getAllIncome() {
  return axios.post(APP_SETTINGS.API_PATH.INCOME.getIncomeList, {
    incomeDescription: "",
    incomeTypeId: 0,
    incomeStatusId: 0,
    fromDate: "",
    toDate: "",
  });
}
export function getFilteredIncome(filteredData) {
  var finalData = {
    incomeDescription: filteredData.description ? filteredData.description : "",
    incomeTypeId: filteredData.incomeType ? filteredData.incomeType : 0,
    incomeStatusId: filteredData.statusId ? filteredData.statusId : 0,
    fromDate: filteredData.fromDate ? filteredData.fromDate : "",
    toDate: filteredData.toDate ? filteredData.toDate : "",
  };
  return axios.post(APP_SETTINGS.API_PATH.INCOME.getIncomeList, finalData);
}
